import { ActivatedRoute } from '@angular/router';
import { GeneralService } from 'src/app/services/general.service';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { AbstractControl, FormGroup, FormBuilder } from '@angular/forms';
import { GeneralComponent } from 'src/app/shared/general.component';
import { Observable } from 'rxjs';
import { DropDownListDTO, DropDownListSiteRecebimentoDTO } from 'src/app/entity/dto/dropdownlist.component';
import { FormularioService } from 'src/app/services/formulario.service';
import { NotificationService } from 'src/app/services/notification.service';
import { FormAreaTypesService } from './../../../../services/form.area.types.service';
import { eAreaType } from 'src/app/entity/enum/enum-area-type';


@Component({
  // tslint:disable-next-line: component-selector
  selector: 'app-cd001-card-classificacao-III',
  templateUrl: './cd001-card-classificacao-III.component.html'
})

export class Cd001CardClassificacaoIIIComponent extends GeneralComponent implements OnInit, OnChanges {
  public formulario?: FormGroup;
  public listSiteRecebimento?: Array<DropDownListSiteRecebimentoDTO> = new Array<DropDownListSiteRecebimentoDTO>();
  public listSiteOrigem?: Array<DropDownListDTO> = new Array<DropDownListDTO>();

  public filteredOptionsSiteRecebimento: Observable<DropDownListSiteRecebimentoDTO[]>;
  public filteredOptionsSiteOrigem: Observable<DropDownListDTO[]>;

  @Output() mkCalc = new EventEmitter();
  @Input() generationValue: number = 0;
  area: string = eAreaType.commercial;

  // tslint:disable-next-line: max-line-length
  constructor(protected formularioService: FormularioService, protected formBuilder: FormBuilder, protected notificationService: NotificationService, protected generalService: GeneralService, private route: ActivatedRoute) {
    super('(%) Retido por Peneiras', false);
    if (this.isComercial) { //comercial
      this.formulario = this.formBuilder.group({
        retido_peneira_vinte_dois_prc: [null, []],
        retido_peneira_vinte_um_prc: [null, []],
        retido_peneira_vinte_prc: [null, []],
        retido_peneira_dezenove_prc: [null, []],
        retido_peneira_dezoito_prc: [null, []],
        retido_peneira_dezessete_prc: [null, []],
        retido_peneira_dezesseis_prc: [null, []],
        retido_peneira_quinze_prc: [null, []],
        vazado_peneira_corresp_furo_redondo_prc: [null, []],
        resultado_retencao: [null, []],
      });
    } else { //básica
      //super('Peneiras de Furo Redondo (% de Retido)', false);
      this.formulario = this.formBuilder.group({
        retido_peneira_vinte_dois_prc: [null, []],
        retido_peneira_vinte_prc: [null, []],
        retido_peneira_dezesseis_prc: [null, []],
        retido_peneira_dezoito_prc: [null, []],
        retido_peneira_quinze_prc: [null, []],
        retido_peneira_r3_prc: [null, []],
        vazado_peneira_corresp_furo_redondo_prc: [null, []],
        resultado_retencao: [null, []],
      })
    }

  }

  public async ngOnInit(): Promise<void> {
    this.getArea()
    this.changeNameSession()
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.generationValue === 1) {
      this.formulario.disable();
    } else {
      this.formulario.enable();
    }
  }


  public changeCollapse(): void {
    this.collapseCard = this.collapseCard ? false : true;
  }

  public hasErrorFormControl(campoFormulario?: AbstractControl): string {
    return this.formularioService.hasErrorFormControl(campoFormulario);
  }

  public async makeCalculations(): Promise<void> {
    this.mkCalc.emit();
  }

  getArea = () => {
    this.route.paramMap.subscribe((paramMap) => {
      this.area = paramMap.get('area');
    });
  };
  changeNameSession = () => {
    switch (this.area) {
      case eAreaType.basic:
        this.step = '(%) Retido por Peneiras';
        break;

      default:
        this.step = 'Peneiras de Furo Redondo (% de Retido)';
        break;
    }
  }


}
